<template>
    <v-card
        v-if="!loaded || (tips && tips.length)"
        :border="outlined"
        :elevation="!outlined ? 0 : null"
        data-cy="general-tip"
    >
        <v-card-title style="word-break: break-word" :class="{'d-flex': true, 'justify-center': center}">
            {{ $t('tips_title') }}
            <v-icon v-if="showClose" class="v-card-close mt-3 me-3" @click="close"> mdi-close </v-icon>
        </v-card-title>
        <v-card-text>
            <v-form v-model="valid">
                <v-skeleton-loader v-if="!loaded" type="list-item-three-line" />
                <template v-else>
                    <div>
                        <div v-for="(tip, index) in uniqueTips" :key="tip.title" class="mb-2">
                            <div class="mb-1 font-weight-bold" v-text="tip.title" />
                            <div class="overflow-hidden" v-html="tip.content" />
                            <v-btn
                                v-if="tip.attach"
                                :loading="loadingPdf"
                                class="cursor-pointer"
                                @click="downloadTipAttach(tip.attach, tip.title)"
                            >
                                <v-icon> mdi-file-download-outline </v-icon>
                            </v-btn>
                            <v-divider v-if="index !== uniqueTips.length - 1" class="my-4" />
                        </div>
                        <template v-if="additionalQuestions && additionalQuestions.length">
                            <v-card-title class="px-0">
                                <v-icon start color="primary">mdi-comment-text</v-icon>
                                {{ $t('questions') }}
                            </v-card-title>
                            <div class="text-subtitle-2 text-primary mb-2">
                                {{ $t('please_provide_answers') }}
                            </div>
                            <div
                                v-for="(answerObj, i) in answersOnQuestions"
                                :key="answerObj.id"
                                class="d-flex flex-column"
                            >
                                <span class="text-subtitle-2 text--secondary">
                                    {{ `${i + 1}.  ${getAnswerLabel(answerObj)}` }}
                                </span>
                                <v-text-field
                                    v-model="answerObj.answer"
                                    :placeholder="$t('type_here')"
                                    :rules="getAnswerRules(answerObj)"
                                />
                            </div>
                        </template>
                    </div>
                </template>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel, Watch} from 'vue-facing-decorator'
    import {downloadDataAsync} from '@/utils/helpers'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class OrderDetailsTips extends mixins(FormValidationRulesMixin) {
        @VModel() valid

        @Prop() tips
        @Prop({default: []}) additionalQuestions
        @Prop() loaded
        @Prop({type: Boolean, default: false}) showClose
        @Prop({default: true, type: Boolean}) outlined
        @Prop({default: false, type: Boolean}) center

        loadingPdf = false
        answersOnQuestions = []

        @Emit()
        close() {}

        @Watch('additionalQuestions', {deep: true, immediate: true})
        onAdditionalQuestionsChange() {
            this.answersOnQuestions = this.additionalQuestions?.map(q => ({questionId: q.id, answer: ''})) || []
        }

        async downloadTipAttach(pdf, title) {
            this.loadingPdf = true
            await downloadDataAsync(`data:application/octet-stream;base64,${pdf}`, `${title}.pdf`).then(() => {
                this.loadingPdf = false
            })
        }

        getAnswerLabel(answerObj) {
            const question = this.additionalQuestions.find(q => q.id === answerObj.questionId)
            return question.questionText + (question.mandatory ? '*' : '')
        }

        getAnswerRules(answerObj) {
            return this.additionalQuestions.find(q => q.id === answerObj.questionId).mandatory
                ? [this.requiredRule('')]
                : []
        }

        get uniqueTips() {
            return [...new Map(this.tips.map(item => [item['title'], item])).values()]
        }
    }

    export default OrderDetailsTips
</script>
